const AmCharts = window.AmCharts;
export default AmCharts;


// WEBPACK FOOTER //
// ./web/js/alias/amcharts.js